import { FC } from "react";
import LookFindrLogo from "../../../assets/images/LookfindrLogo";
import { useIntl } from "react-intl";

interface FooterProps {}

const Footer: FC<FooterProps> = ({}) => {
  const intl = useIntl();
  return (
    <div className="w-full h-[65px] bg-[#EEF0FF] flex items-center justify-center">
      <small className="text-[#B0B0C0] mx-2">
        {intl.formatMessage({ id: "providedBy" })}
      </small>
      <LookFindrLogo />
    </div>
  );
};

export default Footer;
